<template>
  <div>
    <div class="page">
      <div class="page__content"
        v-if="getModuleConfig('content')"
        v-html="getModuleConfig('content')"
      ></div>
    </div>

    <div class="page__button s-space-y-4">
      <MemberButton
        v-if="getModuleConfig('button_text')"
        :button-text="getModuleConfig('button_text')"
        :button-url="getModuleConfig('button_url')"
        :type="getModuleConfig('button_action')"
      >
      </MemberButton>
    </div>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";

export default {
  components: {
    MemberButton,
  },

  data() {
    return {
      page: "",
      showLoading: false,
    };
  },

  created() {
    this.page = this.$route.params.autoPage + "_page";
  },

  mounted() {
    // Web version: No LIFF initialization or messages
  },

  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('liff_page', this.page + '.' + key);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .page__content img {
  max-width: 100%;
}
</style>
